import { render, staticRenderFns } from "./Input_Date.vue?vue&type=template&id=5df87fdc"
import script from "./Input_Date.vue?vue&type=script&lang=js"
export * from "./Input_Date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports